import React from "react";

function Loading() {
  return (
    <i
      className="fa fa-gear fa-spin fadeInOut"
      style={{
        fontSize: "32px",
        opacity: 0.8,
        top: "50%",
        left: "50%",
        position: "absolute",
        transform: "translate(-50%, -50%)",
      }}
    />
  );
}
export default Loading;
